var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { id: "vue-wf-event-listing" } },
        [
          _c("wf-event-listing", {
            attrs: { "event-filter-options": _vm.eventFilterOptions },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var eventFilter = ref.eventFilter
                  return _vm._l(_vm.eventsList, function(event) {
                    return _c(
                      "div",
                      { key: event.event_Title },
                      [
                        _c(
                          "wf-event-listing-item",
                          {
                            attrs: {
                              "event-type": event.Event_Type,
                              "event-filter": eventFilter
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "wf-event-listing-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "wf-event-listing-item-section"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "wf-event-date-box" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "wf-event-date-box-month"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(event.event_Date) +
                                                " " +
                                                _vm._s(event.event_Date.year) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "wf-event-date-box-day"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(event.event_Date.day) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "wf-event-listing-item-section"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "wf-event-date-time" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(event.event_Date) +
                                            " " +
                                            _vm._s(event.event_Timings) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "secondary-heading" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(event.event_Type) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "h3 mb-0" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(event.event_Title) +
                                          "\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "call-to-action-button btn btn-white border-dark mt-3",
                                        attrs: { href: event.NodeAlias }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  View details\n                  "
                                        ),
                                        _c("span", {
                                          staticClass:
                                            "png-icon png-icon-icons-glyph--k-arrow-next "
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  })
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wf-get-in-touch wf-get-in-touch-reverse-colors" },
        [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "section-content" }, [
              _c("div", { staticClass: "container-fluid" }, [
                _c("div", { staticClass: "wf-get-in-touch-wrapper" }, [
                  _c("h2", { staticClass: "h1" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.data.title) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.data.description) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "call-to-action-button btn btn-primary",
                      attrs: { href: _vm.data.ctaLink }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.data.ctaText) +
                          "\n              "
                      ),
                      _c("span", {
                        staticClass:
                          "png-icon png-icon-icons-glyph--ko-arrow-next "
                      })
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("wf-back-to-top-button")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }